(() => {
  class FilterSearch extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector(".filter-item__filters");
      this.search = this.querySelector(".filter-search__field");
      this.reset = this.querySelector(".filter__remover-button");
      this.delete = this.querySelector(".filter-search__delete");
      this.selectedFilters = this.querySelector(".filter__selected-filters");
      this.selected = 0;
      this.selectedFiltersValues = [];
      this.priceFilter = this.content.querySelector("input").type === "radio";

      this.hiddenContent = this.querySelector(".accordion__content--filter");
    }

    connectedCallback() {
      if (this.search) {
        this.search.addEventListener("input", () => {
          this.onChange();
        });

        this.delete.addEventListener("click", (e) => {
          e.preventDefault();
          this.querySelector(".filter-search__field").value = "";
          this.close();
        });
      }

      this.reset.addEventListener("click", () => {
        this.resetFilters();
      });

      this.content.querySelectorAll("input").forEach((target) => {
        target.addEventListener("change", () => {
          if (this.priceFilter) {
            this.checkboxChangePrice(target);
          } else {
            this.checkboxChange(target);
          }
        });
      });

      this.populateSelectedFilters();
      this.attachAnimation();

      if (this.selected === 0) {
        this.reset.classList.add("hidden");
      }
    }

    attachAnimation() {
      const head = this.querySelector(".accordion__head--filter");
      const toExpand = this.querySelector(".accordion__content--filter");
      head.addEventListener("click", () => {
        if (this.classList.contains("isOpen")) {
          toExpand.style.maxHeight = `0`;
          this.classList.remove("isOpen");
        } else {
          toExpand.style.maxHeight = `${toExpand.scrollHeight}px`;
          this.classList.add("isOpen");
        }
      });
    }

    populateSelectedFilters() {
      this.content.querySelectorAll("input").forEach((target) => {
        if (target.checked) {
          if (this.priceFilter) {
            this.checkboxChangePrice(target, false);
          } else {
            this.checkboxChange(target, false);
          }
        }
      });
    }

    resetFilters(sendEvent = true) {
      this.content.querySelectorAll("input").forEach((input) => {
        input.checked = false;
      });
      this.selectedFilters.innerText = "Alles";
      this.selected = 0;
      this.selectedFiltersValues = [];
      this.reset.classList.add("hidden");
      if (sendEvent) {
        this.sendUpdateEvent();
      }
    }

    sendUpdateEvent() {
      const eventFilterUpdate = new CustomEvent("filterUpdate", {
        bubbles: true,
        detail: this,
      });
      this.dispatchEvent(eventFilterUpdate);
    }

    checkboxChangePrice(target, sendEvents = true) {
      const targetAttribute = this.stripRelevantURL(
        target.getAttribute("data-filter-to-add")
      );
      const selectedFilter =
        target.parentElement.querySelector("span").innerText;
      this.selectedFilters.innerText = selectedFilter;
      this.selectedFiltersValues = [targetAttribute];

      this.handleFilterResetBtn();
      if (sendEvents) {
        this.sendUpdateEvent();
      }
    }

    handleFilterResetBtn() {
      this.reset.classList.remove("hidden");
      this.hiddenContent.style.maxHeight = `calc(${this.hiddenContent.style.maxHeight} + 24px + 16px)`;
    }

    checkboxChange(target, sendEvents = true) {
      const targetAttribute = this.stripRelevantURL(
        target.getAttribute("data-filter-to-add")
      );
      const selectedFilter =
        target.parentElement.querySelector("span").innerText;
      if (target.checked) {
        if (this.selected === 0) {
          this.selectedFilters.innerText = selectedFilter;
          this.handleFilterResetBtn();
        } else {
          this.selectedFilters.innerText += `, ${selectedFilter}`;
        }
        this.selected += 1;
        this.selectedFiltersValues.push(targetAttribute);
      } else {
        this.selected -= 1;
        if (this.selected === 0) {
          this.selectedFilters.innerText = "Alles";
          this.reset.classList.add("hidden");
        } else {
          this.selectedFilters.innerText =
            this.selectedFilters.innerText.replace(`${selectedFilter}, `, "");
          this.selectedFilters.innerText =
            this.selectedFilters.innerText.replace(`, ${selectedFilter}`, "");
        }
        const indexToDelete =
          this.selectedFiltersValues.indexOf(targetAttribute);
        this.selectedFiltersValues.splice(indexToDelete, 1);
      }
      if (sendEvents) {
        this.sendUpdateEvent();
      }
    }

    stripRelevantURL(url) {
      let newUrl = url.slice(url.indexOf("?") + 1);
      return newUrl;
    }

    getFilterURLs() {
      return this.selectedFiltersValues;
    }

    onChange() {
      const searchTerm = this.search.value.trim().toLowerCase();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.search.classList.add("isSearching");
      this.searchFilters(searchTerm);
    }

    searchFilters(searchTerm) {
      this.content.querySelectorAll("span").forEach((span) => {
        if (span.innerText.toLowerCase().includes(searchTerm)) {
          span.parentElement.classList.remove("hidden");
        } else {
          span.parentElement.classList.add("hidden");
        }
      });
    }

    close() {
      this.search.classList.remove("isSearching");
      this.content.querySelectorAll("label").forEach((label) => {
        label.classList.remove("hidden");
      });
      this.style.maxHeight = `${this.scrollHeight}px`;
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get("filter-search-custom")) {
    customElements.define("filter-search-custom", FilterSearch);
  }
})();
